import { useMutation } from "@tanstack/react-query";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useRef, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DCSQueryClient } from "../../../../../queryClient";
import { UserRoles } from "../../../../../constants/userRoles";
import { useToast } from "../../../../../Providers/ToastProvider";
import { useUser } from "../../../../../keycloak";
import { requests } from "../../../../../services/http-common";
import { ConfirmationModal } from "../../../../../components/ConfirmationModal/ConfirmationModal";

export const Actions = (rowData: {
  id: string;
  isOneTimePasswordSent: boolean;
}) => {
  const menu = useRef(null);
  const navigate = useNavigate();
  const { show } = useToast();
  const user: any = useUser();
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);

  const deleteClient = useMutation({
    mutationFn: () => {
      return requests.delete(`/client/${rowData.id}`);
    },
    onSuccess: () => {
      show({ detail: "The client was deleted successfully !" });
      DCSQueryClient.invalidateQueries({ queryKey: ["client-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  const sendEmail = useMutation({
    mutationFn: () => {
      return requests.put(`/client/send-email/${rowData.id}`);
    },
    onSuccess: () => {
      show({ detail: "The setup email was successfully sent." });
      DCSQueryClient.invalidateQueries({ queryKey: ["client-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  const items = useMemo(() => {
    let _items: any = [];

    if (user?.roles.dcs_client.includes(UserRoles.CLIENT_VIEW)) {
      _items.push({
        label: "View",
        command: () => {
          navigate(`/sales/client/${rowData.id}/details`);
        },
      });
    }

    if (user?.roles.dcs_client.includes(UserRoles.CLIENT_UPDATE)) {
      _items.push({
        label: "Edit",
        command: () => {
          navigate(`/sales/client/${rowData.id}/details/edit`);
        },
      });
    }

    if (user?.roles.dcs_client.includes(UserRoles.CLIENT_DELETE)) {
      _items.push({
        label: "Delete",
        command: () => {
          setShowDeletePopup(true);
        },
      });
    }

    if (user?.roles.dcs_client.includes(UserRoles.CLIENT_UPDATE)) {
      _items = [
        {
          label: "Resend Setup Email",
          command: () => {
            sendEmail.mutate();
          },
        },
        ..._items,
      ];
    }

    return _items;
  }, [sendEmail, navigate, rowData.id, deleteClient, user]);

  return (
    <>
      <Menu model={items} popup ref={menu} id="popup_menu" />
      <ConfirmationModal
        visible={showDeletePopup}
        onHide={() => setShowDeletePopup(false)}
        accept={() => deleteClient.mutate()}
        reject={() => setShowDeletePopup(false)}
      />
      <Button
        icon="pi pi-ellipsis-v"
        //@ts-ignore
        onClick={(event) => menu.current.toggle(event)}
        aria-controls="popup_menu"
        aria-haspopup
        className="p-button-rounded p-button-text"
        disabled={!items.length}
      />
    </>
  );
};
